import LoginCell from './LoginCell';

export default LoginCell;
